/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Pagination from "../../../Helper/Pagination";
import { API_URL } from "../../../Services/ApiService";
import { GetService } from "../../../Services/ConstantService";
import { BounceLoader } from "react-spinners";
import { format, parseISO } from "date-fns";
import { Link } from "react-router-dom";

export default function Orders() {
  // const [activePage, setActivePage] = useState(1);
  const [Loading, setLoading] = useState(false);
  const [OrderList, setOrderList] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [userLimit, setUserLimit] = useState(10);

  // const handlePageChange = (pageNumber) => {
  //   console.log(`active page is ${pageNumber}`);
  //   setActivePage(pageNumber);

  // };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  useEffect(() => {
    getOrderList();
  }, [currentPage]);

  const getOrderList = () => {
    setLoading(true);
    GetService(`${API_URL.GET_ORDER_LIST}?page=${currentPage}`).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setOrderList(res?.data?.data?.item);
        setTotalPages(res.data?.data?.totalPages);
        setTotal(res?.data?.data?.totalItems);
      }
      setLoading(false);
    });
  };

  return (
    <div
      className="tab-pane fade active show"
      id="nav-Labeling"
      role="tabpanel"
      aria-labelledby="nav-Labeling-tab"
      tabIndex={0}
    >
      <div className="col-xl-12 col-lg-12 col-md-6">
        <div className="heading">
          <p>My Order History</p>
        </div>
      </div>
      <div className="Section3 ">
        <div className="container user-profile ">
          {OrderList?.length > 0 && (
            <div className="DataTable1 table-sm table-responsive">
              <table className="table first data table table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">Order ID</th>
                    <th scope="col">Location</th>
                    <th scope="col">Order Amount</th>
                    <th scope="col">Order Items</th>
                    <th scope="col">Order Status</th>
                    <th scope="col">Order Date</th>
                    <th scope="col">Detail</th>
                  </tr>
                </thead>
                <tbody>
                  {OrderList &&
                    OrderList.map((data) => (
                      <tr>
                        {/* <td><Link to={`details/${data?.id}`}>{data?.order_no}</Link></td> */}
                        <td>{data?.order_no}</td>
                        <td>{data?.baddress1}</td>
                        <td className="text-center text-primary fw-semibold">${parseFloat(data.total_amount).toLocaleString()}</td>
                        <td className="ps-5">{data?.orderItems.length}</td>
                        {/* <td className="text-image">
                        <div className="mr-10">
                          <img
                            src="assets/img/breadcrumb/Rectangle 6.png"
                            alt=""
                          />
                        </div>
                        <div className="image-list">
                          <h6>Canvas prints</h6>
                          <h5>₹ 700</h5>
                        </div>
                      </td>  */}
                        <td>
                          <div>
                            <span
                              className={`list-button large head shippied text-uppercase text-white rounded-5 px-1 ${
                                data?.order_status === "Delivered"
                                  ? "bg-success"
                                  : data?.order_status === "Cancel Order"
                                  ? "bg-danger"
                                  : "bg-primary"
                              }`}
                              style={{ fontSize: "xx-small" }}
                            >
                              {data?.order_status === "Cancel Order"
                                ? "Cancelled"
                                : data?.order_status}
                            </span>
                          </div>
                        </td>
                        {/* <td className="uppercase list-button large head shippied">{data?.order_status}</td> */}
                        <td>
                          {data?.created_at
                            ? format(
                                parseISO(data?.created_at),
                                "dd-MM-yyyy HH:mm"
                              )
                            : "N/A"}
                        </td>
                        <td className="">
                          <Link to={`details/${data?.id}`}>
                            <div className="btn btn-sm btn-warning rounded-5">
                              view
                            </div>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}

          {OrderList?.length < 1 && (
            <div className="mt-45 mb-50 d-flex align-items-center justify-content-center">
              <img
                src="assets/img/breadcrumb/nodata.png"
                alt=""
                style={{ height: "320px", width: "320px" }}
              />
            </div>
          )}
        </div>
      </div>

      {Loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#003bff"}
            loading={Loading}
            speedMultiplier={2}
            size={50}
          />
          <div>Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}

      {OrderList?.length > 0 && (
        <Pagination
          counting={currentPage * userLimit}
          totaldata={total}
          pagecount={totalPages}
          onChangePage={handlePageClick}
          activePage={currentPage}
        />
      )}
    </div>
  );
}
